import Cookies from "js-cookie"
import React from "react"
import classnames from "classnames"

import style from "./popover.module.scss"

class Popover extends React.Component {
  constructor() {
    super()

    this.state = { visible: true }
  }

  close = () => {
    this.setState({ visible: false })
    Cookies.set(this.props.cookie, "true", {
      expires: 20 * 365,
      samesite: "lax"
    })
  }

  render() {
    if (Cookies.get(this.props.cookie) || !this.state.visible) {
      return null
    }

    const { container, close } = style
    const { content, color, position } = this.props
    const classNames = classnames(container, color && style[color], position && style[position])

    return (
      <div className={classNames}>
        {content}
        <button type="button" className={close} onClick={this.close}>
          <i className="fa fa-close"></i>
        </button>
      </div>
    )
  }
}

export default Popover



// WEBPACK FOOTER //
// ./components/popover/popover.jsx